import React, { useState, useMemo } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"
import { navigate, graphql, useStaticQuery } from "gatsby"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import MediaCard from "../../internal/mediaCard/MediaCard"
import PaginationControls from "../../internal/paginationControls/PaginationControls"

import * as styles from "./MediaListingPanel.module.scss"


function MediaTypeToLabel(type) {
  switch (type) {
    case "media_brochure":
      return <FormattedMessage id="component.panel.media_listing_panel.label_brochure" />
    case "media_press_release":
      return <FormattedMessage id="component.panel.media_listing_panel.label_press_release" />
    case "media_video":
      return <FormattedMessage id="component.panel.media_listing_panel.label_video" />
    case "media_webinar":
      return <FormattedMessage id="component.panel.media_listing_panel.label_webinar" />
    case "media_documentation":
      return <FormattedMessage id="component.panel.media_listing_panel.label_documentation" />
    case "media_infographic":
      return <FormattedMessage id="component.panel.media_listing_panel.label_infographic" />
    default:
      return ""
  }
}
function MediaTypeToCtaText(type) {
  switch (type) {
    case "media_brochure":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_brochures" />
    case "media_press_release":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_press_releases" />
    case "media_video":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_videos" />
    case "media_webinar":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_webinars" />
    case "media_documentation":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_documentation" />
    case "media_infographic":
      return <FormattedMessage id="component.panel.media_listing_panel.cta_infographic" />
    default:
      return ""
  }
}
function TruncateString(str, limit) {
  if (str && str.length > limit) {
    return str.substring(0, limit) + "..."
  }
  return str
}
const PER_PAGE = 9
const MediaListingPanel = ({ blok, cardData, locale }) => {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  )
  const baseurl = site.siteMetadata.siteUrl;

  const initialData = cardData ? cardData : []
  const hasBrochures = useMemo(() => { return cardData.find((card) => { return card.type === "media_brochure" }) ? true : false }, cardData)
  const hasPressReleases = useMemo(() => { return cardData.find((card) => { return card.type === "media_press_release" }) ? true : false }, cardData)
  const hasVideos = useMemo(() => { return cardData.find((card) => { return card.type === "media_video" }) ? true : false }, cardData)
  const hasWebinars = useMemo(() => { return cardData.find((card) => { return card.type === "media_webinar" }) ? true : false }, cardData)
  const hasDocumentation = useMemo(() => { return cardData.find((card) => { return card.type === "media_documentation" }) ? true : false }, cardData)
  const hasInfographic = useMemo(() => { return cardData.find((card) => { return card.type === "media_infographic" }) ? true : false }, cardData)

  const [currentFilter, setCurrentFilter] = useState("")
  const [currentLanguageFilter, setCurrentLanguageFilter] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const intl = useIntl()

  const [cards, setCards] = useState(initialData)
  const [typeCards, setTypeCards] = useState(initialData)

  const numPages = Math.ceil(cards.length / PER_PAGE)

  function applyfilters(typeFilter, languageFilter) {
    return cardData.filter((d) => {
      var include = true;

      if (typeFilter != "" && include) {
        include = d.type === typeFilter;
      }

      if (languageFilter != "" && include) {
        include = d.language === languageFilter;
      }

      return include;
    });
  }
  function applytypefilter(typeFilter) {
    return cardData.filter((d) => {
      var include = true;

      if (typeFilter != "" && include) {
        include = d.type === typeFilter;
      }

      return include;
    });
  }


  function updateCardsFilter(value) {
    setCurrentFilter(value)
    if (currentPage !== 1) {
      setCurrentPage(1)
    }
    var thecards = applyfilters(value, currentLanguageFilter)
    var typeCards = applytypefilter(value);
    if (thecards.length > 0) {
      setCards(thecards);
    }
    else {
      //clear out the language filter
      setCurrentLanguageFilter("")
      setCards(typeCards);
    }

    setTypeCards(typeCards);
  }

  function updateCardsLanguageFilter(value) {
    if (value == "fr_link") {
      navigate("/fr/media/");
      return;
    }


    setCurrentLanguageFilter(value)
    if (currentPage !== 1) {
      setCurrentPage(1)
    }
    setCards(applyfilters(currentFilter, value));
    setTypeCards(applytypefilter(currentFilter));
  }

  function onClickFilter(type) {
    updateCardsFilter(type)
  }

  function handleSelectFilter(e) {
    updateCardsFilter(e.target.value)
  }

  function handlePageChanged(page) {
    setCurrentPage(page)
  }

  function handleLanguageSelectFilter(e) {
    updateCardsLanguageFilter(e.target.value)
  }

  function onClickLanguageFilter(language) {
    updateCardsLanguageFilter(language)
  }



  function compare(a, b) {
    if (a.headline < b.headline) {
      return -1
    }
    if (a.headline > b.name.headline) {
      return 1
    }
    return 0
  }

  function sortFilters(a, b) {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  }

  cards.sort(compare)

  var filters = useMemo(() => {
    let filterList = []
    if (hasDocumentation) { filterList.push({ filter: "media_documentation", id: "component.panel.media_listing_panel.filter_documentation", title: intl.messages["component.panel.media_listing_panel.filter_documentation"] }) }
    if (hasInfographic) { filterList.push({ filter: "media_infographic", id: "component.panel.media_listing_panel.filter_infographic", title: intl.messages["component.panel.media_listing_panel.filter_infographic"] }) }
    if (hasBrochures) { filterList.push({ filter: "media_brochure", id: "component.panel.media_listing_panel.filter_brochures", title: intl.messages["component.panel.media_listing_panel.filter_brochures"] }) }
    if (hasPressReleases) { filterList.push({ filter: "media_press_release", id: "component.panel.media_listing_panel.filter_press_releases", title: intl.messages["component.panel.media_listing_panel.filter_press_releases"] }) }
    if (hasVideos) { filterList.push({ filter: "media_video", id: "component.panel.media_listing_panel.filter_videos", title: intl.messages["component.panel.media_listing_panel.filter_videos"] }) }
    if (hasWebinars) { filterList.push({ filter: "media_webinar", id: "component.panel.media_listing_panel.filter_webinars", title: intl.messages["component.panel.media_listing_panel.filter_webinars"] }) }
    return filterList.sort(sortFilters)
  }, [cardData])

  var languageFilters = useMemo(() => {
    let languageFilterList = [];

    for (var i = 0; i < typeCards.length; i++) {
      if (!languageFilterList.find((filter) => { return filter.value === typeCards[i].language ? true : false })) {
        languageFilterList.push({ value: typeCards[i].language, id: "component.panel.media_listing_panel.lang_" + typeCards[i].language, title: intl.messages["component.panel.media_listing_panel.lang_" + typeCards[i].language] });
      }
    }

    //add french if english
    if (locale == 'en') {
      languageFilterList.push(
        {
          value: "fr_link",
          id: "component.panel.media_listing_panel.lang_fr_link",
          title: intl.messages["component.panel.media_listing_panel.lang_fr_link"]
        }
      )
    }

    return languageFilterList.sort(sortFilters)
  }, [typeCards])


  return (
    <PanelWrapper blok={blok}>
      <Container>
        <Row>
          <div className="mobileOnly">
            {(languageFilters.length > 1) && (
              <div className={styles.filterGroup}>
                <h4><FormattedMessage id="component.panel.media_listing_panel.language_filter" /></h4>
                <select value={currentLanguageFilter} onChange={handleLanguageSelectFilter}>
                  <option value="">{intl.messages["component.panel.media_listing_panel.language_filter_all"]}</option>
                  {languageFilters.map(f => <option value={f.value}>{f.title}</option>)}
                </select>
              </div>
            )}
            <div className={styles.filterGroup}>
              <h4><FormattedMessage id="component.panel.media_listing_panel.filter_title" /></h4>
              <select value={currentFilter} onChange={handleSelectFilter}>
                <option value="">{intl.messages["component.panel.media_listing_panel.filter_all"]}</option>
                {filters.map(f => <option value={f.filter}>{f.title}</option>)}
              </select>
            </div>
          </div>
          <Col xs={12} md={3} className="desktopOnly">
            {(languageFilters.length > 1) && (
              <div className={styles.filterGroup}>
                <h4><FormattedMessage id="component.panel.media_listing_panel.language_filter" /></h4>
                <ul className={styles.filterList}>
                  <li className={currentLanguageFilter === "" ? styles.active : ""}>
                    <button onClick={() => { onClickLanguageFilter("") }}><FormattedMessage id="component.panel.media_listing_panel.language_filter_all" /></button>
                  </li>
                  {languageFilters.map(f => <li key={f.id} className={currentLanguageFilter === f.value ? styles.active : ""}><button onClick={() => { onClickLanguageFilter(f.value) }}><FormattedMessage id={f.id} /></button></li>)}
                </ul>
              </div>
            )}
            <div className={styles.filterGroup}>
              <h4><FormattedMessage id="component.panel.media_listing_panel.filter_title" /></h4>
              <ul className={styles.filterList}>
                <li className={currentFilter === "" ? styles.active : ""}>
                  <button onClick={() => { onClickFilter("") }}><FormattedMessage id="component.panel.media_listing_panel.filter_all" /></button>
                </li>
                {filters.map(f => <li key={f.id} className={currentFilter === f.filter ? styles.active : ""}><button onClick={() => { onClickFilter(f.filter) }}><FormattedMessage id={f.id} /></button></li>)}
              </ul>
            </div>

          </Col>
          <Col xs={12} md={9}>
            <Row>
              {cards.filter((card, idx) => {
                // Filter current page
                return (idx + 1 > ((currentPage - 1) * PER_PAGE) && idx + 1 <= PER_PAGE * currentPage)
              }).map((card) => (
                <Col xs={12} sm={6} lg={4} key={card.id}>
                  <MediaCard
                    type={card.type}
                    label={MediaTypeToLabel(card.type)}
                    title={card.headline}
                    excerpt={TruncateString(card.excerpt, 120)}
                    cta_text={MediaTypeToCtaText(card.type)}
                    cta_link={card.link}
                    target={card.target}
                    file={card.download_file} />
                </Col>
              ))}
            </Row>
            <div>
              <br />
              <div style={{ float: "right" }}>
                {numPages > 1 ? (
                  <PaginationControls numPages={numPages} currentPage={currentPage} onClickPage={handlePageChanged} />
                ) : null}
              </div>
              <div style={{ clear: "both" }} />
            </div>
          </Col>
        </Row>
      </Container>
    </PanelWrapper>
  )
}

export default MediaListingPanel